module.exports = __webpack_public_path__ + "img/download-linux-app-btn.d4059d9e.webp";